import { Dictionary } from 'vue-router/types/router';

export const RouterUtils = {
  replaceRouteParameterValuesWithPlaceholders(routePath: string, routeParams: Dictionary<string>, routeWithoutParams: string, parametersToReplace: string[]): string {
    if (routeParams == null) {
      return routePath;
    }
    const routeWithoutParametersParts = routeWithoutParams.split('/');
    const routeParts = routePath.split('/');
    const routeParameterKeys = Object.entries(routeParams).map((entry) => ':'.concat(entry[0]));

    const routeWithPlaceholders = routeParts.map((part: string, index: number) => {
      const isParameterToReplace = parametersToReplace.includes(routeWithoutParametersParts[index]) && routeParameterKeys.includes(routeWithoutParametersParts[index]);

      if (isParameterToReplace) {
        return routeWithoutParametersParts[index];
      }
      return part;
    });

    return routeWithPlaceholders.join('/');
  },
  replaceRouteParameterPlaceholdersWithValues(routeWithPlaceholders: string | null, routeParameters: any): string {
    if (routeWithPlaceholders === null) {
      return '';
    }

    if (routeParameters == null) {
      return routeWithPlaceholders;
    }

    const routeWithPlaceholdersParts = routeWithPlaceholders.split('/');
    const parameters: Record<string, string | number> = Object.fromEntries(Object.entries(routeParameters).map(([key, value]) => [key, String(value)]));
    const routeWithParameterValues = routeWithPlaceholdersParts.map((part: string) => {
      const result = Object.entries(parameters).filter(([key, value]) => part === ':'.concat(key));
      if (result.length === 1) {
        return result[0][1];
      }
      return part;
    });

    return routeWithParameterValues.join('/');
  }
};
